import { authHeader } from '@/_helpers'
export const adminService = {
  getLastUsers,
  getActive,
  getGmailImports,
  getLinkedinImports,
  getOliverSettings,
  getOliverVariables,
  updateWords,
  updateOliverVariables,
  insertNew,
  getOwarmStats,
  spamCheckRunTest,
  getOwarmList,
  getOwarmListTotal,
  getCampaignStepTemplates,
  getCampaignStepTemplate,
  setCampaignStepTemplate,
  deleteCampaignStepTemplate,
  getCampaignStepTemplateTypes,
  addCampaignStepTemplateTypes,
  getEmailsQueueList,
  getEmailsQueueListTotal,
  getEmailsQueueStats,
  getEmailSyncList,
  changePaymentStatus,
  setClientPaymentMethod,
  sendCodeGoogle,
  getCsv,
  setCsv,
  verifyApollo,
  getLandingPage,
  updateStatusLandingPage,
  insertOliverVariables,
  getListOwarm,
  getDeliverabilityByProviderHistory,
  getTargetSalesWithoutProspectors,
  getSpamCheckStatsByTarget,
  getSpamCheckUsersByTarget,
  spamCheckHistoryByUser,
  callRingOver,
  getCallsRingOver,
  getAppointmentPrices,
  setAppointmentPrices,
  getCallsUnreachableRingOver,
  getPhoneDirectory,
  getMicrosoftLicences,
  getSmartleadStats,
  getAllOptionsClaims,  
  saveClaimToMeeting,
  dispatchClaimJudge,
  getClaimN8nPayload,
  getClaimSalesridgeResponse,
  getClaimsContactsInformation,
  autoCreateCancelClaim,
  runLinkedinEnrich,
  runJudge,
  getAllClaims,
  updateStatusClaimToMeeting,
  getTotalNewClaims,
  getEventInClaim,
  getClientStatsByMonth,
  getEventsByRange,
  getProspectCampaignSentEmails,
  getLinkEmailMessages,
  getElevenLabsAudio,
  updateAgentPrompts,
  exportClientAnalyse,
  analyseClientCalls,
  getCallQualification,
  updateQualificationByNotification,
}

const apiUrl = process.env.VUE_APP_ROOT_API

function getLastUsers() {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({}),
  }
  return fetch(`${apiUrl}/admin/lastusers`, requestOptions).then(handleResponse)
}

function getAllOptionsClaims() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/admin/claims-reasons`, requestOptions).then(handleResponse)
}

function getAllClaims(filters = {}) {
  // Build query string from filters
  const queryParams = new URLSearchParams()
  
  if (filters.link_event_id !== undefined && filters.link_event_id !== null) {
    queryParams.append('link_event_id', filters.link_event_id)
  }
  
  if (filters.claim_reason_id !== undefined && filters.claim_reason_id !== null) {
    queryParams.append('claim_reason_id', filters.claim_reason_id)
  }
  
  if (filters.status !== undefined && filters.status !== null) {
    queryParams.append('status', filters.status)
  }
  
  if (filters.oliver_sale !== undefined && filters.oliver_sale !== null) {
    queryParams.append('oliver_sale', filters.oliver_sale)
  }

  if (filters.limit !== undefined && filters.limit !== null) {
    queryParams.append('limit', filters.limit)
  }

  if (filters.offset !== undefined && filters.offset !== null) {
    queryParams.append('offset', filters.offset)
  }
  
  const queryString = queryParams.toString()
  const url = queryString 
    ? `${apiUrl}/admin/claims?${queryString}`
    : `${apiUrl}/admin/claims`
  
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(url, requestOptions).then(handleResponse)
}

function getTotalNewClaims(){
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/admin/total-new-claims`, requestOptions).then(handleResponse)
}

function getEventInClaim(link_id){
  const requestOptions = {
      method: 'GET',
      headers: authHeader('application/json')
  };
  return fetch(`${apiUrl}/admin/this-event-has-claim/${link_id}`, requestOptions).then(handleResponse);
}

function saveClaimToMeeting(claim) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ link_event_id: claim.link_event_id, 
                           claim_reason_id: claim.claim_reason_id, 
                           details: claim.details, 
                           status: claim.status  })
  }
  return fetch(`${apiUrl}/admin/claims`, requestOptions).then(handleResponse)
}

function dispatchClaimJudge(claimId) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ claim_id: claimId })
  }
  return fetch(`${apiUrl}/admin/claims/judge-dispatch`, requestOptions).then(handleResponse)
}

function getClaimN8nPayload(claimId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json')
  }
  return fetch(`${apiUrl}/admin/claims/test-n8n-payload/${claimId}`, requestOptions).then(handleResponse)
}

function getClaimSalesridgeResponse(claimId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json')
  }
  return fetch(`${apiUrl}/admin/claims/salesridge-response/${claimId}`, requestOptions).then(handleResponse)
}

function getClaimsContactsInformation(claimIds) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ claim_ids: claimIds })
  }
  return fetch(`${apiUrl}/admin/claims/contacts-information`, requestOptions).then(handleResponse)
}

function autoCreateCancelClaim(link_id, claim_reason_id, details) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ link_id, claim_reason_id, details })
  }
  return fetch(`${apiUrl}/admin/claims/auto-cancel`, requestOptions).then(handleResponse)
}

function runLinkedinEnrich(link_id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ link_id })
  }
  return fetch(`${apiUrl}/admin/claims/linkedin-enrichment`, requestOptions).then(handleResponse)
}

function runJudge(link_event_id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ link_event_id })
  }
  return fetch(`${apiUrl}/admin/claims/judge/run`, requestOptions).then(handleResponse)
}

function updateStatusClaimToMeeting(claim) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ id: claim.id, status: claim.status })
  }
  return fetch(`${apiUrl}/admin/claims`, requestOptions).then(handleResponse)
}

function verifyApollo() {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({}),
  }
  return fetch(`${apiUrl}/admin/verifyapollo`, requestOptions).then(handleResponse)
}

function getAppointmentPrices(){
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }

  return fetch(`${apiUrl}/admin/get-appt-prices`,requestOptions,).then(handleResponse)
}

function setAppointmentPrices(appt_prices){
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({appt_prices}),
  }
  return fetch(`${apiUrl}/admin/set-appt-prices`, requestOptions).then(handleResponse)
}


function getCsv(count = null) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ count }),
  }
  return fetch(`${apiUrl}/admin/getcsvapollo`, requestOptions).then(handleResponse)
}

function setCsv() {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({}),
  }
  return fetch(`${apiUrl}/admin/setcsvapollo`, requestOptions).then(handleResponse)
}

function getActive() {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({}),
  }
  return fetch(`${apiUrl}/admin/activecampaigns`, requestOptions).then(
    handleResponse,
  )
}

function getEmailsQueueList(model) {
  model.total = 0
  let searchFilter = getDefault(model)
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ searchFilter }),
  }
  return fetch(
    `${apiUrl}/admin/get-emails-queue/filtered-list`,
    requestOptions,
  ).then(handleResponse)
}

function getEmailsQueueListTotal(model) {
  model.total = 1
  let searchFilter = getDefault(model)
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ searchFilter }),
  }

  return fetch(
    `${apiUrl}/admin/get-emails-queue/filtered-list`,
    requestOptions,
  ).then(handleResponse)
}

function getEmailsQueueStats(model) {
  let searchFilter = getDefault(model)
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ searchFilter }),
  }
  return fetch(`${apiUrl}/admin/get-emails-queue/stats`, requestOptions).then(
    handleResponse,
  )
}

function getOliverSettings(wordListComplete) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify(wordListComplete),
  }
  return fetch(`${apiUrl}/admin/settings`, requestOptions).then(handleResponse)
}

function updateOliverVariables(words, name) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ words, name }),
  }
  return fetch(`${apiUrl}/admin/updateolivervariable`, requestOptions).then(
    handleResponse,
  )
}

function insertOliverVariables(word, name) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ word, name }),
  }
  return fetch(`${apiUrl}/admin/insertolivervariable`, requestOptions).then(
    handleResponse,
  )
}

function getOliverVariables(name) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ name }),
  }
  return fetch(`${apiUrl}/admin/getvariables`, requestOptions).then(
    handleResponse,
  )
}

function updateWords(words, id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ words, id }),
  }
  return fetch(`${apiUrl}/admin/updatewords`, requestOptions).then(
    handleResponse,
  )
}

function getMicrosoftLicences() {
    const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/admin/microsoft-licences`, requestOptions).then(
    handleResponse,
  )
}

function insertNew(words, title, type) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ words, title, type }),
  }
  return fetch(`${apiUrl}/admin/insertwords`, requestOptions).then(
    handleResponse,
  )
}

function getGmailImports() {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({}),
  }
  return fetch(`${apiUrl}/admin/gmailimports`, requestOptions).then(
    handleResponse,
  )
}

function getLinkedinImports() {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({}),
  }
  return fetch(`${apiUrl}/admin/linkedinimports`, requestOptions).then(
    handleResponse,
  )
}

function getOwarmStats(model) {
  let searchFilter = model
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ searchFilter }),
  }
  return fetch(`${apiUrl}/owarm/stats`, requestOptions).then(handleResponse)
}

function getSpamCheckStatsByTarget(target_id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ target_id }),
  }
  return fetch(`${apiUrl}/owarm/spam-check-stats-by-target`, requestOptions).then(handleResponse)
}
function getSpamCheckUsersByTarget(target_id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ target_id }),
  }
  return fetch(`${apiUrl}/owarm/spam-check-users-by-target`, requestOptions).then(handleResponse)
}
function spamCheckHistoryByUser(owarm_id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ owarm_id }),
  }
  return fetch(`${apiUrl}/owarm/spam-check-history-by-user`, requestOptions).then(handleResponse)
}
function spamCheckRunTest(owarm_id, email) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ owarm_id, email }),
  }
  return fetch(`${apiUrl}/owarm/spam-check-run-test`, requestOptions).then(handleResponse)
}

function getOwarmList(model) {
  model.total = 0
  let searchFilter = model
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ searchFilter }),
  }
  return fetch(`${apiUrl}/owarm/filtered-list`, requestOptions).then(
    handleResponse,
  )
}


function getSmartleadStats(){
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/admin/smartlead-stats`, requestOptions).then(
    handleResponse,
  )
}

function getOwarmListTotal(model) {
  model.total = 1
  let searchFilter = model
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ searchFilter }),
  }

  return fetch(`${apiUrl}/owarm/filtered-list`, requestOptions).then(
    handleResponse,
  )
}

function getCampaignStepTemplates(model) {
  let searchFilter = getDefault(model)
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ searchFilter }),
  }

  return fetch(
    `${apiUrl}/admin/get-campaign-step-templates`,
    requestOptions,
  ).then(handleResponse)
}

function getCampaignStepTemplate(model) {
  let searchFilter = getDefault(model)
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ searchFilter }),
  }

  return fetch(
    `${apiUrl}/admin/get-campaign-step-template`,
    requestOptions,
  ).then(handleResponse)
}

function setCampaignStepTemplate(template) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ template }),
  }

  return fetch(`${apiUrl}/admin/campaign-step-template`, requestOptions).then(
    handleResponse,
  )
}

function deleteCampaignStepTemplate(id) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader('application/json'),
  }

  return fetch(
    `${apiUrl}/admin/campaign-step-template/${id}`,
    requestOptions,
  ).then(handleResponse)
}

function getCampaignStepTemplateTypes() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }

  return fetch(
    `${apiUrl}/admin/get-campaing-step-template-types`,
    requestOptions,
  ).then(handleResponse)
}

function addCampaignStepTemplateTypes(data) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify(data),
  }

  return fetch(
    `${apiUrl}/admin/add-campaing-step-template-types`,
    requestOptions,
  ).then(handleResponse)
}

function getEmailSyncList(active, count = null) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ active, count }),
  }

  return fetch(`${apiUrl}/admin/get-email-sync-list`, requestOptions).then(
    handleResponse,
  )
}

function getLandingPage(count = false) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  const value = (count) ? true : false
  return fetch(`${apiUrl}/admin/get-landing-page?count=${value}`, requestOptions).then(
    handleResponse,
  )
}

function getListOwarm(active, count = 0) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/owarm/get-list-owarm?count=${count}&active=${active}`, requestOptions).then(
    handleResponse,
  )
}

function getDeliverabilityByProviderHistory() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/owarm/get-deliverability-provider-history`, requestOptions).then(
    handleResponse,
  )
}

function getTargetSalesWithoutProspectors(active, count = 0) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/targets/get-target-sales-without-prospectors?count=${count}&active=${active}`, requestOptions).then(
    handleResponse,
  )
}

function updateStatusLandingPage(params) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ client_id: params.client_id, url: params.url }),
  }

  return fetch(`${apiUrl}/admin/update-status-landing-page`, requestOptions).then(
    handleResponse,
  )
}

function sendCodeGoogle(code) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ code }),
  }

  return fetch(`${apiUrl}/google-api/callback`, requestOptions).then(
    handleResponse,
  )
}

function callRingOver(ring_to,link,name){
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ ring_to,link,name }),
  }
  return fetch(`${apiUrl}/admin/ringover-call`, requestOptions).then(
    handleResponse,
  )
}


function getCallsUnreachableRingOver(searchFilter){
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ searchFilter}),
  }
  return fetch(`${apiUrl}/admin/get-ringover-calls-unreachable`, requestOptions).then(
    handleResponse,
  )
}

function getPhoneDirectory(searchFilter){
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ searchFilter }),
  }
  return fetch(`${apiUrl}/admin/get-phone-directory`, requestOptions).then(
    handleResponse,
  )
}

function getCallsRingOver(searchFilter){
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ searchFilter}),
  }
  return fetch(`${apiUrl}/admin/get-ringover-calls`, requestOptions).then(
    handleResponse,
  )
}

function updateAgentPrompts(updates, agent) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ updates, agent }),
  }
  return fetch(`${apiUrl}/admin/update-agent-prompts`, requestOptions).then(handleResponse)
}

function changePaymentStatus(id, payment_status_id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ id, payment_status_id }),
  }

  return fetch(`${apiUrl}/payments/change-status`, requestOptions).then(
    handleResponse,
  )
}

function setClientPaymentMethod(client_id, payment_method_type, payment_method_id = null) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ client_id, payment_method_type, payment_method_id }),
  }

  return fetch(`${apiUrl}/payments/admin-set-client-payment-method`, requestOptions).then(
    handleResponse,
  )
}

function getClientStatsByMonth(year){
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/admin/get-client-stats-by-month?year=${year}`, requestOptions).then(
    handleResponse,
  )
}

function getEventsByRange(params) {
  let userId = params.user_id
  if (params.account_id != null && params.account_id !== '') {
    try {
      const decoded = typeof atob !== 'undefined' ? atob(params.account_id) : ''
      userId = decoded ? parseInt(decoded, 10) : params.user_id
    } catch (e) {
      userId = params.user_id
    }
  }
  const body = {
    user_id: userId,
    hours_back: params.hours_back != null ? params.hours_back : 2,
    hours_forward: params.hours_forward != null ? params.hours_forward : 30,
  }
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify(body),
  }
  return fetch(`${apiUrl}/admin/calendar/events-by-range`, requestOptions).then(handleResponse)
}

function getDefault(model) {
  let searchFilter = Array()
  searchFilter = {
    filters:
      model.filters !== undefined
      ? model.filters
      : undefined,
    currentPage:
      model.currentPage !== undefined
        ? JSON.stringify(model.currentPage)
        : undefined,
    cantPerPage:
      model.cantPerPage !== undefined
        ? JSON.stringify(model.cantPerPage)
        : undefined,
    total: model.total !== undefined ? JSON.stringify(model.total) : undefined,
    allItems: model.allItems !== undefined ? JSON.stringify(model.allItems) : undefined,
    client_id:
      model.client_id !== undefined
        ? JSON.stringify(model.client_id)
        : undefined,
    from_owarm_id:
      model.from_owarm_id !== undefined
        ? JSON.stringify(model.from_owarm_id)
        : undefined,
    step: model.step !== undefined ? model.step : undefined,
    campaign_step_template_type_id:
      model.campaign_step_template_type_id !== undefined
        ? model.campaign_step_template_type_id
        : undefined,
    campaign_step_template_part_id:
      model.campaign_step_template_part_id !== undefined
        ? model.campaign_step_template_part_id
        : undefined,
    id: model.id !== undefined ? model.id : undefined,
    parent_id: model.parent_id !== undefined ? model.parent_id : undefined,
    language_id:
      model.language_id !== undefined ? model.language_id : undefined,
    isPreviewEmail:
      model.isPreviewEmail !== undefined ? model.isPreviewEmail : undefined,
    tag_id: model.tag_id !== undefined ? model.tag_id : undefined,
    withTags: model.withTags !== undefined ? model.withTags : undefined,
    queue_status:
      model.queue_status !== undefined ? model.queue_status : undefined,
    tab_selected:
      model.tab_selected !== undefined ? model.tab_selected : undefined,
  }
  return searchFilter
}

function getProspectCampaignSentEmails(client_id, email){
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/admin/prospect-campaign-sent-emails?client_id=${client_id}&email=${email}`, requestOptions).then(handleResponse)
}

function getLinkEmailMessages(link_id, email) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  const q = new URLSearchParams({
    link_id: String(link_id),
    email: email == null ? '' : String(email).trim(),
  })
  return fetch(
    `${apiUrl}/admin/get-link-email-messages?${q.toString()}`,
    requestOptions
  ).then(handleResponse)
}

function getElevenLabsAudio(conversationId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };
  return fetch(
    `${apiUrl}/admin/calls/${conversationId}/audio`,
    requestOptions
  ).then(res => {
    if (!res.ok) throw new Error('HTTP ' + res.status);
    return res.blob();
  });
}

function analyseClientCalls(clientId, callIds) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ callIds }),
  }

  return fetch(
    `${apiUrl}/admin/clients/${clientId}/analyse`,
    requestOptions
  ).then(handleResponse)
}

function exportClientAnalyse(clientId, callIds) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ callIds }),
  }

  return fetch(
    `${apiUrl}/admin/clients/${clientId}/analyse/export`,
    requestOptions
  ).then(async (response) => {
    const contentType = response.headers.get('content-type') || ''

    if (!response.ok || contentType.includes('application/json')) {
      let errorPayload
      try {
        errorPayload = await response.json()
      } catch (e) {
        errorPayload = { error: response.statusText || `HTTP ${response.status}` }
      }
      return Promise.reject(errorPayload)
    }

    const blob = await response.blob()

    let filename = `maestro-payload-${clientId}.zip`
    const disposition = response.headers.get('content-disposition') || ''
    const match = disposition.match(/filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i)
    if (match && match[1]) {
      try {
        filename = decodeURIComponent(match[1])
      } catch (e) {
        filename = match[1]
      }
    }

    return { blob, filename }
  })
}

function getCallQualification(notification_id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(
    `${apiUrl}/admin/get-call-qualification?notification_id=${notification_id}`,
    requestOptions,
  ).then(handleResponse)
}

function updateQualificationByNotification(notification_id, meeting_status, response) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ notification_id, meeting_status, response }),
  }
  return fetch(
    `${apiUrl}/admin/update-qualification-by-notification`,
    requestOptions,
  ).then(handleResponse)
}

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text)
    if (!response.ok) {
      const error = data || response.statusText
      return Promise.reject(error)
    }
    return data
  })
}
